module.exports = __webpack_public_path__ + "static/media/ic_change_pdf_24px.12d5686a.svg";